import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../input-base/input-base';

const INPUT_TEXT_VALUE_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	// eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
	useExisting: forwardRef(() => InputTextComponent),
	multi: true,
};

@Component({
	selector: 'app-input-text',
	templateUrl: './input-text.component.html',
	styleUrls: ['../input-base/input-styles.scss', './input-text.component.scss'],
	providers: [INPUT_TEXT_VALUE_ACCESSOR],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InputTextComponent extends InputBase implements ControlValueAccessor {
	@Input() maxlength: number = null;

	@Input() minlength: number = null;
}
